import { useEffect, useState, useReducer } from 'react';
import getIntersections from './getIntersections';
import { useDispatch, useSelector } from 'react-redux';
import OverlayBox from './OverlayBox';
import { IMAGE_SETS, IMAGE_UPLOADS } from './RecordTypes';
import G from './Getters';

const image = require("./images/1.jpeg");

function FileItem({name,onClick, id,overlapping=[],selected=[],children}){

  //let dragInfo = useDragInfo();

  return (
    <div 
      
      style={{fontSize:10,padding:5,borderTop:'1px solid #ccc', borderRight:'1px solid #ccc',}}
      onClick={onClick} 
      class={` rel ${selected.includes(""+id)?"selected":""}`} item={"filename"} id={id}>
      {children.map(item => {
        return (
          <div>{item.filesystemName}</div>
        )
      })}
      {overlapping.includes(""+id) && <div class="npe selected-item-cover"/>}
    </div>
  )
}



export default function LooseData({
  setLooseItemsSelected,
  looseItemsSelected,
  processExecutionId,
  onGroup
}){

  const selected = looseItemsSelected;
  const setSelected = setLooseItemsSelected;

  const [ start, setStart ] = useState();
  const [ end, setEnd ] = useState();
  const dispatch = useDispatch();

  const dragDiagonal = [start,end];

  let overlappingDivs = getIntersections(dragDiagonal,"[item=filename]")
  let selectBoxIds = overlappingDivs.map(x => x.id);


  let fsDict = useSelector(state => {
    let activeImageSetIds = G.getActiveItemIds(state,{type:IMAGE_SETS});

    return Object.fromEntries(activeImageSetIds.map((_id) => {
      let {images} = G.getImageSet(state,_id);


      let children = images.map(_id => ({ _id, 
        filesystemName:G.getFilesystemName(state,{type:IMAGE_UPLOADS,_id})
      }));

      let filesystemName = G.getFilesystemName(state,{type:IMAGE_SETS,_id});

      return [ _id, { _id, children, filesystemName }]
    }))
  });

  let fsItems = Object.values(fsDict);



  let fileDivs = fsItems.map(({_id,filesystemName,children},iiFsItem) => {
    return <FileItem onClick={(e) =>{
      //e.stopPropagation();
      //e.preventDefault();
      setSelected([_id])
    }} 
    children={children}
    name={filesystemName}
    id={_id} 
    drag={selectBoxIds} 
    selected={selected} />
  })

  

  return (


     
    <div style={{
      minHeight:0,
    }} class="sg-col rel full-height full-width">

      
      <div style={{borderBottom:'1px solid #ccc'}} class="small-padding">
        <h5>Loose Data 
          <button onClick={onGroup}>Group</button>
        </h5>
      </div>

      <div class="flex-expand rel" 
      style={{
        
        overflow:'scroll',
        minHeight:0, 

      }} 
      onMouseUp={e => {
        if( e.target.tagName === "BUTTON" ){
          return;
        }
        setSelected([]);
        setStart();
        setEnd();
      }}
      >


        <div>
      </div>

        <div style={{minHeight:0}} class="sg-row rel full-height">
          <div
            onMouseDown={e => {
              //e.stopPropagation();
              //if( dontUnselect(e) ){ return; }


              let point = [e.clientX, e.clientY];
              setStart(point);
              setEnd(point);
            }}
            onMouseMove={(e) => {

              if( !start ){
                return;
              }
              let point = [e.clientX, e.clientY];

              setEnd(point);

            }}
            onMouseUp={e => {
              e.stopPropagation();
              e.preventDefault();


              let overlappingDivs = getIntersections([start,end],"[item=filename]")
              let selectBoxIds = overlappingDivs.map(x => x.id);

              /*
              console.log("SELECTING END!");
              console.log({start,end});
              console.log({selectBoxIds});
              */

              setSelected(selectBoxIds);

              //if( dontUnselect(e) ){ return; }
              setStart(null);
              setEnd(null);

            }}
            //style={{flexWrap:'wrap'}}

            class="sg-col">
            {fileDivs}
          </div>
          <div>

            <div>{false && JSON.stringify(selectBoxIds)}</div>
            <div>{false && JSON.stringify(selected)}</div>
            <div>{false && JSON.stringify({start,end})}</div>






          </div>
        </div>

        <OverlayBox diagonal={[start,end]}/>

      </div>
    </div>
  )

}





